export default function MoneyFormatter ({ value }) {
  const currency = (value) => new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
  }).format(value / 100)

  return (
    <>{currency(value)}</>
  )
}